import {rules as v} from '../scripts/rules';

const befundbeschreibung = {
  "Befundnr"                : v.isNum,
  
  // 2021-03-31  soll wie "befundbeschreibung/strat. unter" sein
  //"Schnittnr"               : v.isNumOrEmpty,
  //"Planumnr"                : v.isNumOrEmpty,
  //"Profilnr"                : v.isNumManyCommaSeparatedOrEmpty, // v.isNumOrEmpty,
  "Schnittnr"               : v.isNumManyCommaSeparatedOrEmpty,
  "Planumnr"                : v.isNumManyCommaSeparatedOrEmpty,
  "Profilnr"                : v.isNumManyCommaSeparatedOrEmpty,
  
  "Form Planum"             : v.formPlanumThes,
  "Form Profil"             : v.formProfilThes,
  "Laenge m"                : v.isNumTwoDecOrEmpty,
  "Breite m"                : v.isNumTwoDecOrEmpty,
  "Durchmesser innen m"     : v.isNumTwoDecOrEmpty,
  "Durchmesser aussen m"    : v.isNumTwoDecOrEmpty,
  "absolute Hoehe in m NHN" : v.isNumTwoDecOrEmpty,
  "relative Tiefe in m"     : v.isNumTwoDecOrEmpty,
  "Sediment"                : v.isFreetext,
  "Farbe"                   : v.isFreetext,
  "Einschluesse"            : v.isFreetext,
  "Abgrenzung"              : v.isFreetext,
  "sonst. Abgrenzung"       : v.isFreetext,
  "Steinmaterial"           : v.isFreetext,
  "Steinmasse"              : v.isFreetext,
  "Steinbearbeitung"        : v.isFreetext,
  "Moertel"                 : v.isFreetext,
  "Mauertechnik"            : v.isFreetext,
  "Ausrichtung"             : v.isFreetext,
  
  "strat. unter"            : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. geschnitten von"  : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. verfuellt von"    : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. angestossen von"  : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. ueber"            : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. schneidet"        : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. stoesst gegen"    : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. verfuellt"        : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. liegt in"         : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. gehoert zu"       : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  "strat. entspricht"       : v.isNumManyCommaSeparatedOrEmpty, // v.isNumManyWithoutDash,
  
  "Beschreibung"            : v.isFreetext,
  
  "Fotonr"                  : v.isNumManyWithoutDash,
  
  "Klassifikation"          : v.classificationThes,
  "Datierung"               : v.DateThes,
  "Interpretation"          : v.isFreetext,
  "Datum"                   : v.isDate,
  "BearbeiterIn"            : v.isFreetextNotEmpty,
  "Verworfen"               : v.isJN
}

export default befundbeschreibung;
